var _linearGradient, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    width: 128
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 594 633)",
    gradientUnits: "userSpaceOnUse",
    id: "instagram_svg__a",
    x1: -566.711,
    x2: -493.288,
    y1: 516.569,
    y2: 621.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9100eb"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "url(#instagram_svg__a)",
    r: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.333 104H45.667C33.72 104 24 94.281 24 82.333V45.667C24 33.719 33.72 24 45.667 24h36.666C94.281 24 104 33.719 104 45.667v36.667C104 94.281 94.281 104 82.333 104zM45.667 30.667c-8.271 0-15 6.729-15 15v36.667c0 8.271 6.729 15 15 15h36.666c8.271 0 15-6.729 15-15V45.667c0-8.271-6.729-15-15-15H45.667z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 84c-11.028 0-20-8.973-20-20 0-11.029 8.972-20 20-20s20 8.971 20 20c0 11.027-8.972 20-20 20zm0-33.333c-7.352 0-13.333 5.981-13.333 13.333 0 7.353 5.981 13.333 13.333 13.333S77.333 71.353 77.333 64c0-7.352-5.98-13.333-13.333-13.333z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.25,
    cy: 42.75,
    fill: "#FFF",
    r: 4.583
  }))));
};
export default SvgInstagram;